import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

const BASE_URL = '/resources';

export default function ResourceComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(ResourceComponent, {
        getAll({ profileId, enterpriseId, extent }: $TSFixMe) {
            return request('/getAll', { profileId, enterpriseId, extent });
        },
        update({ profileId, enterpriseId, resourceUpdates }: $TSFixMe) {
            return request('/update', { profileId, enterpriseId, resourceUpdates });
        },
    });
}
